import type { ReactNode } from 'react';

/**
 * Reproduces the two Elementor container shapes the original page uses.
 *
 * Every section on the live site sits inside one of these, and their padding is
 * what produces the vertical rhythm between blocks. Without them the rebuilt
 * page renders each section correctly but ~520px shorter overall, because all
 * the inter-section spacing disappears.
 *
 * Measured from the live site at 1440px:
 *   boxed  → outer `padding: 0 10px`, inner `max-width: min(100%, 1250px)`,
 *            inner `padding: 10px 0`
 *   full   → outer `padding: 10px 10px 0`, `gap: 20px`
 */
export function SectionContainer({
  children, variant = 'boxed', className, style,
}: {
  children: ReactNode;
  variant?: 'boxed' | 'full';
  className?: string;
  style?: React.CSSProperties;
}) {
  if (variant === 'full') {
    return (
      <div className={`cng-con cng-con-full${className ? ` ${className}` : ''}`} style={style}>
        {children}
      </div>
    );
  }
  return (
    <div className={`cng-con cng-con-boxed${className ? ` ${className}` : ''}`} style={style}>
      <div className="cng-con-inner">{children}</div>
    </div>
  );
}
